export const clearCustomerData = () => {
  try {
    if (window.salja?.customerProfile?.clearCustomerData) {
      window.salja.customerProfile.clearCustomerData();
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Failed to Clear Customer data:", error);
  }
  return null;
};
